import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withTheme } from 'styled-components';

import { MoreInformationModal } from '../MoreInformationModals';

const AddContactMoreInformationModal = ({ theme, isModalOpen, onRequestClose }) => {
  const { t } = useTranslation();
  return (
    <MoreInformationModal
      isModalOpen={isModalOpen}
      onRequestClose={onRequestClose}
      contentList={[
        {
          title: t('addNewContacts'),
          description: t('addContactDesc'),
          icon: (
            <Icon
              name="add-contact"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          ),
          images: [
            {
              src: theme.images.addContactMoreInformation11,
              alt: t('uploadSpreadsheet')
            },
            {
              src: theme.images.addContactMoreInformation12,
              alt: t('syncFromSalesforce')
            }
          ]
        }
      ]}
    />
  );
};

export default withTheme(AddContactMoreInformationModal);
